import { performPatchRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getJpdViewsServicePathPrefix } from '@jira/polaris__lib-jpd-views-service/src/index.tsx';
import type { NavigationView } from './NavigationView.types.tsx';

export const updateView = (
	viewId: string,
	params: {
		viewType: 'LIST' | 'TIMELINE' | 'BOARD' | 'MATRIX' | 'SECTION' | 'TREE';
		name?: string;
		emoji?: string;
	},
): Promise<NavigationView> =>
	performPatchRequest(`${getJpdViewsServicePathPrefix()}/v1/views/${viewId}`, {
		body: JSON.stringify(params),
	});
